import { useCallback, useState } from 'react';

import { SUCCESS } from '@app/constants';
import { useUserPrint } from '@app/hooks';
import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';
import { useSetCompletedForCrmTasksMutation } from '@app/services/rtkQuery/CrmTasks/api';

export const useFinishTaskModal = () => {
  const { activeBranchId: ActiveBranchId } = useUserPrint();
  const { showNotification } = useNotification();

  const [isFinishTaskModalOpen, setIsFinishTaskModalOpen] = useState(false);

  const [setCompletedForCrmTasks, { isLoading: isCompletingTaskLoading }] =
    useSetCompletedForCrmTasksMutation();

  const openFinishTaskModal = useCallback(() => {
    setIsFinishTaskModalOpen(true);
  }, []);

  const closeFinishTaskModal = useCallback(() => {
    setIsFinishTaskModalOpen(false);
  }, []);

  const finishTasks = useCallback(
    async (CrmTaskIds: Array<number>) => {
      try {
        await setCompletedForCrmTasks({ ActiveBranchId, CrmTaskIds }).unwrap();

        showNotification('', SUCCESS);

        closeFinishTaskModal();
      } catch (error) {
        showNotification(error);
      }
    },
    [
      ActiveBranchId,
      closeFinishTaskModal,
      setCompletedForCrmTasks,
      showNotification,
    ]
  );

  return {
    isFinishTaskModalOpen,
    openFinishTaskModal,
    closeFinishTaskModal,
    finishTasks,
    isCompletingTaskLoading,
  };
};
